import { ComboboxBase } from './ComboboxBase'
import type {
  ComboboxClassNames,
  ComboboxHandle,
  ComboboxModeProps,
  SharedProps,
  SingleProps,
} from './types'

export type TypeaheadHandle = ComboboxHandle
export type TypeaheadClassNames<T> = ComboboxClassNames<T>
export type TypeaheadProps<T = string> = SharedProps<T> &
  ComboboxModeProps<T> &
  Omit<SingleProps<T>, 'multiple'>

export function Typeahead<T = string>(props: TypeaheadProps<T>) {
  return <ComboboxBase<T> {...props} />
}
